import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const SmileIcon: React.FC<IconBaseProps> = ({ color = 'currentColor', width = 24, height = 24 }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path d="M12 .5C18.4.5 23.5 5.6 23.5 12S18.4 23.5 12 23.5.5 18.4.5 12 5.6.5 12 .5zm0 20.7c5.1 0 9.2-4.1 9.2-9.2S17.1 2.8 12 2.8 2.8 6.9 2.8 12s4.1 9.2 9.2 9.2zm4-10.3c-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7c1 0 1.7.8 1.7 1.7s-.7 1.7-1.7 1.7zm-8 0c-1 0-1.7-.8-1.7-1.7S7 7.4 8 7.4s1.7.8 1.7 1.7-.8 1.8-1.7 1.8zm9.5 3.2a5.66 5.66 0 0 1-11.2 0h11.2z" />
    </IconBase>
  );
};

export default SmileIcon;
